// Excel експортът на „По категории".
//
// Редовете идват ФИЛТРИРАНИ и ПОДРЕДЕНИ от таблицата (`onFilteredRowsChange`),
// не суровият набор: файлът повтаря екрана. Числата остават ЧИСЛА — процент
// като „12,3 %" в клетка убива всяко сравнение в Excel.

import { exportToExcel } from "../../../../utils/excelExport";
import type { CategoryRow } from "./categoriesMath";

type ExportContext = {
  t: (key: string) => string;
  /** „По категории" — заглавието на справката, то е и името на файла. */
  reportName: string;
};

const rounded = (value: number | null): number | string =>
  value === null ? "" : Number(value.toFixed(2));

export const exportCategories = (
  rows: CategoryRow[],
  { t, reportName }: ExportContext,
): void => {
  exportToExcel<CategoryRow>({
    // БЕЗ собствен времеви печат — `exportToExcel` вече лепи `_${stamp}`.
    filename: reportName,
    sheetName: reportName,
    columns: [
      {
        header: t("reportsPage.category"),
        value: (row) =>
          row.isLunch
            ? `${row.categoryName} (${t("reportsPage.lunchTag")})`
            : row.categoryName,
        width: 28,
      },
      {
        header: t("reportsPage.itemsColCount"),
        value: (row) => rounded(row.quantity),
        width: 12,
      },
      {
        header: t("reportsPage.averagePrice"),
        value: (row) => rounded(row.avgPrice),
        width: 14,
      },
      {
        header: t("reportsPage.itemsColRevenue"),
        value: (row) => rounded(row.revenue),
        width: 14,
      },
      {
        header: t("reportsPage.itemsColShare"),
        value: (row) => rounded(row.sharePercent),
        width: 12,
      },
      {
        header: t("reportsPage.categoriesColDelta"),
        value: (row) => rounded(row.deltaPercent),
        width: 16,
      },
    ],
    rows,
  });
};
